"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var components_1 = require("../../components");
var themes_1 = require("../../themes");
var StyledList_1 = require("./StyledList");
var createMarkup = function (content) {
    return { __html: content };
};
var ListInner = function (_a) {
    var listStyleColor = _a.listStyleColor, unordered = _a.unordered, content = _a.content, theme = _a.theme, font = _a.font;
    var listItems = content.map(function (contentItem, idx) {
        if (contentItem) {
            return (React.createElement(StyledList_1.StyledListItem, { key: idx, color: listStyleColor ? listStyleColor : themes_1.colors['secondaryBlue-1'], fontColor: themes_1.colors.primaryText, theme: theme, font: font }, typeof contentItem === 'string' ? React.createElement(components_1.Text, { dangerouslySetInnerHTML: createMarkup(contentItem) }) : contentItem));
        }
        return null;
    });
    if (unordered) {
        return React.createElement(StyledList_1.StyledUnorderedList, null, listItems);
    }
    else {
        return React.createElement(StyledList_1.StyledOrderedList, null, listItems);
    }
};
ListInner.defaultProps = {
    listStyleColor: themes_1.colors['secondaryBlue-1'],
    unordered: true,
    content: []
};
/** @component */
exports.List = recompose_1.compose(styled_components_1.withTheme)(ListInner);
//# sourceMappingURL=List.js.map